export default "/images/985acb6ea2692bac53b548a8d72031ec.png";